import TableUsuarios from "../../Components/Tables/TableUsuarios";
import TopBar from "../../Layout/TopBar/TopBar";
import './RegistroUsuarios.scss'

const RegistrosUsuarios = () => {

    return (
        <div style={{display:"flex", flexDirection:"column"}}>
            <TopBar />
            <TableUsuarios />
        </div>
    );
}

export default RegistrosUsuarios;